import { render, staticRenderFns } from "./WithdrawHistories.vue?vue&type=template&id=10658a3a"
import script from "./WithdrawHistories.vue?vue&type=script&lang=js"
export * from "./WithdrawHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports